export function isMainConfigurationPage(name) {
  const links = [
    'configuration',
    'shaftV2Configuration',
    'shipConfiguration',
    'equipmentConfiguration',
    'organisationConfiguration',
  ];

  return links.find(link => name === link);
}

export function headerNav(name) {
  const links = {
    'plant': `plants.configuration.${name}.nav`,
    'shaft': `shafts.configuration.${name}.nav`,
    'ship': `ships.configuration.${name}.nav`,
    'equipment': `equipment.configuration.${name}.nav`,
    'organisation': `configuration.${name}.nav`,
  };

  return links[name] || null;
}

export function mainConfigurationPage(name) {
  const links = {
    // Plants
    'configurationPlants': 'configuration',
    'configurationHme': 'configuration',
    // ShaftsV2
    'shaftV2ConfigurationShafts': 'shaftV2Configuration',
    'shaftV2ConfigurationStations': 'shaftV2Configuration',
    'shaftV2ConfigurationHme': 'shaftV2Configuration',
    // Ships
    'shipConfigurationShips': 'shipConfiguration',
    'shipConfigurationsHme': 'shipConfiguration',
    // Equipment
    'equipmentConfigurationEquipment': 'equipmentConfiguration',
    // Organisation
    'editOrganisationConfiguration': 'organisationConfiguration',
    'mineConfiguration': 'organisationConfiguration',
    'equipmentProcessConfiguration': 'organisationConfiguration',
    'equipmentTypeConfiguration': 'organisationConfiguration',
    'operationTypeConfiguration': 'organisationConfiguration',
  };

  return links[name] || null;
}
